// @flow strict

import * as React from 'react';
import Localize from '@ta/platform.i18n';
import Abbreviate from './Abbreviate';

import styles from './AbbreviateWithMore.css';

type Props = {|
  text: string,
  max: number,
|};

type State = {|
  expanded: boolean,
|};

/**
 * Abbreviates text if necessary, allowing expansion with a 'more' link.
 * This is different from the <ReadMore> components, as it operates based on
 * character count instead of line.
 *
 * @param {string} text - The text to abbreviate
 * @param {number} max - The maximum length to return
 */
class AbbreviateWithMore extends React.Component<Props, State> {
  state = { expanded: false };

  toggle = () => this.setState({ expanded: !this.state.expanded });

  render() {
    const { text, max } = this.props;
    const { expanded } = this.state;

    if (expanded || text.length < max) {
      // No need to truncate
      return text;
    }

    return (
      <React.Fragment>
        <Abbreviate text={text} max={max} />
        <a className={styles.more} onClick={this.toggle}>
          {/* More */}
          <Localize id="more_link" />
        </a>
      </React.Fragment>
    );
  }
}

export default AbbreviateWithMore;
